module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Dokumente.c6cb4199.svg";